import anime from 'animejs/lib/anime.es.js';

window.addEventListener('DOMContentLoaded', function () {
    const informationBlockLists = document.querySelectorAll('.information-block__listContainer-inner');
    const informationBlockItems = document.querySelectorAll('.information-block .information-block__listItem');
    let lastEvent = null
    const fadeSpeet = 500;
    const imageFadeSpeed = 700;

    const handleMouseEnter = event => {
        lastEvent = "handleMouseEnter";
        const $this = event.target;

        if (!$this.parentNode.classList.contains('information-block__listItem--active')) {
            $this.parentNode.classList.add('information-block__listItem--active');
        }

        anime({
            targets: $this.parentNode.parentNode.querySelectorAll('.information-block__listItem:not(.information-block__listItem--active) > .information-block__listItem-content'),
            duration: fadeSpeet,
            opacity: 0.3,
            easing: 'easeInOutQuad',
        })

        if ($this.style.opacity != 1) {
            anime({
                targets: $this,
                duration: fadeSpeet,
                opacity: 1,
                easing: 'easeInOutQuad',
            })
        }

        if ($this.parentNode.classList.contains('information-block__listItem--active')) {
            anime({
                targets: $this.parentNode.querySelector('.information-block__listItem-image'),
                delay: 0,
                duration: imageFadeSpeed,
                opacity: 1,
                easing: 'easeInOutQuad',
            })
        }

    }

    const handleMouseLeave = event => {
        lastEvent = "handleMouseLeave";
        if (event.target.parentNode.classList.contains('information-block__listItem--active')) {
            event.target.parentNode.classList.remove('information-block__listItem--active');

            anime({
                targets: event.target.parentNode.querySelectorAll('.information-block__listItem-image'),
                duration: imageFadeSpeed,
                opacity: 0,
                easing: 'easeInOutQuad',
            })


            const images = document.querySelectorAll(".information-block__listItem-image")

            images.forEach(image => {
                if (image.alt !== event.target.parentNode.querySelector('.information-block__listItem-image').alt) {
                    image.style.opacity = "0"
                }

            })


        } else {
            anime({
                targets: event.target.parentNode.querySelector('.information-block__listItem-image'),
                duration: imageFadeSpeed,
                opacity: 1,
                easing: 'easeInOutQuad',
            })


        }

        this.setTimeout(function () {
            if ((lastEvent == "handleListMouseEnter" || lastEvent == "handleMouseLeave") && !document.querySelectorAll("information-block__listItem--active").length) {
                anime({
                    targets: document.querySelector('.information-block__listItem:first-of-type .information-block__listItem-image'),
                    duration: imageFadeSpeed,
                    opacity: 1,
                    easing: 'easeInOutQuad',
                })
            }
        }, 250)

    }

    const handleListMouseLeave = event => {
        lastEvent = "handleListMouseLeave";
        anime({
            targets: event.target.querySelectorAll('.information-block__listItem > .information-block__listItem-content'),
            duration: fadeSpeet,
            opacity: 1,
            easing: 'easeInOutQuad',
        })


    }

    const handleListContainerMouseLeave = event => {
        lastEvent = "handleListContainerMouseLeave";
        anime({
            targets: event.target.querySelector('.information-block__listItem:first-of-type .information-block__listItem-image'),
            duration: imageFadeSpeed,
            opacity: 1,
            easing: 'easeInOutQuad',
        })
    }

    const handleListMouseEnter = event => {

    }

    if (window.innerWidth >= 992) {
        informationBlockItems.forEach((item, index) => {
            item.querySelector('.information-block__listItem-content').addEventListener('mouseenter', handleMouseEnter);
            item.querySelector('.information-block__listItem-content').addEventListener('mouseleave', handleMouseLeave);
   

            if (index != 0) {
                const image = item.querySelector('.information-block__listItem-image');
                image.style.opacity = 0;
                //image.style.visibility = 'hidden';
            }

            /*           item.addEventListener('mouseenter', handleListMouseEnter);*/
            item.addEventListener('mouseleave', handleListMouseLeave);
        });

        informationBlockLists.forEach(list => {
            list.addEventListener('mouseenter', handleListMouseEnter);
            list.addEventListener('mouseleave', handleListMouseLeave);
            list.addEventListener('mouseleave', handleListContainerMouseLeave);
        });
    }

})